import { LetsTalkProps, LetsTalkName } from "./types"
import { Person } from "./person"
import * as React from "react"
import * as styles from "./styles.module.scss"
import Button from "../Button"
import cx from "classnames"

const getPerson = (name: LetsTalkName) => {
  switch (name) {
    case LetsTalkName.Charlie:
      return Person.Charlie
    case LetsTalkName.Elizabeth:
    default:
      return Person.Elizabeth
  }
}

const LetsTalk: React.FC<LetsTalkProps> = ({
  nmlsCode,
  subhead,
  button,
  heading,
  headingMaxWidth,
  className,
  buttonClass,
  name = LetsTalkName.Elizabeth,
}) => {
  const img = getPerson(name)

  return (
    <section
      className={cx({
        [styles.letsTalk]: true,
        [className]: !!className,
      })}
    >
      <div className={styles.pagePadding}>
        <div className={styles.figureWrapper}>
          <figure className={styles.figure}>
            <img
              className={styles.image}
              src={img.small.src}
              srcSet={`${img.large.src} ${img.large.width}, ${img.small.src} ${img.small.width}`}
              alt={img.alt}
              sizes="50vw"
            />
          </figure>
        </div>
        <div className={styles.message}>
          <div className={styles.textWrapper}>
            <h3
              className={styles.heading}
              style={{
                maxWidth: headingMaxWidth ? `${headingMaxWidth}em` : undefined,
              }}
            >
              {heading}
            </h3>
            <p className={styles.body}>
              {subhead}
              {nmlsCode && (
                <span className={styles.nmlsCode}> NMLS ID {nmlsCode}</span>
              )}
            </p>
          </div>
          {button && (
            <Button
              type={button.type || "primary"}
              size={button.size || "xxl"}
              halo={true}
              className={buttonClass}
              target="_blank"
              href={button.url}
            >
              {button.text}
            </Button>
          )}
        </div>
      </div>
    </section>
  )
}

export default LetsTalk
